import { render, staticRenderFns } from "./ent-prj-cfg.vue?vue&type=template&id=a163ab06&scoped=true&"
import script from "./ent-prj-cfg.vue?vue&type=script&lang=js&"
export * from "./ent-prj-cfg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a163ab06",
  null
  
)

export default component.exports